import { render, staticRenderFns } from "./Form_4.vue?vue&type=template&id=634dbf8d&scoped=true"
import script from "./Form_4.vue?vue&type=script&lang=js"
export * from "./Form_4.vue?vue&type=script&lang=js"
import style0 from "./Form_4.vue?vue&type=style&index=0&id=634dbf8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dbf8d",
  null
  
)

export default component.exports